

function Features() {
    const features = [
        {
            title: '1L+',
            desc: 'Active Profiles'
        },
        {
            title: '∞',
            desc: 'Clients'
        }
        ,
        {
            title: '∞',
            desc: 'Industries'
        }
        ,
        {
            title: '100%',
            desc: 'Automations'
        }
    ]

    return (
        <div className='p-4 py-14 sm:p-8 md:p-12 2xl:px-[10%] flex gap-2 sm:gap-4 flex-wrap md:flex-nowrap justify-center md:justify-evenly items-center'>
            {
                features?.map((feature, i) => (
                    <div className='p-2 text-center' key={i}>
                        <p className='font-bold text-2xl sm:text-4xl text-primary-400'>{feature.title}</p>
                        <h4>{feature.desc}</h4>
                    </div>
                ))
            }
        </div>
    )
}

export default Features